// prod
export const VUE_APP_BASE_API = "https://crm.crcspace.cn"  
// tesst
// export const VUE_APP_BASE_API = "https://crcspace.merchant.oramage.com"

